import notificationService from "data/notification"
import { local } from 'data/lib/local-json'
import _ from "lodash"

const whitelist = [
  'snapshot',
  'msg/svc_calc',
  'cancel/calc',
  'report',
  'reports',
  'user',
  'notifications',
  'query/propertysummarybar/',
  'validate',
  'validation',
  'migration',
  'history',
  'upload',
  'restore',
  'msg/svc_delete_property',
  'msg/svc_delete_folder',
]

const isReportOnly = () => {
  const subscriptionstatus = _.get(local("auth.profile"), "subscriptionStatus")
  if(subscriptionstatus === "expired" || subscriptionstatus === "cancelled") return true
}

const allowReportOnly = (route, method) => {
  const subscriptionstatus = _.get(local("auth.profile"), "subscriptionStatus")
  if(subscriptionstatus !== "expired" && subscriptionstatus !== "cancelled") return true
  if(_.some(whitelist, (w) => _.startsWith(route, w))) return true
  else return false
}

export { isReportOnly, allowReportOnly }
